module.exports = __webpack_public_path__ + "media/img/partner-6-c9b20284.png";